import React from 'react';
import PropTypes from 'prop-types';
import createMarkup from 'helpers/createMarkup';
import Section from 'components/common/Section';
import IconGroup from 'components/common/icon/IconGroup';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getConfigFromConfigsByKey } from 'y4/Falcon';
import is from 'is_js';
import _ from 'lodash';

const FooterTitle = ({ children }) => (
  <h5 className="text-uppercase text-white opacity-85 mb-3">{children}</h5>
);

FooterTitle.propTypes = { children: PropTypes.node.isRequired };

const FooterList = ({ list }) => (
  <ul className="list-unstyled">
    {list.map(({ title, to }, index) => (
      <li className="mb-1" key={index}>
        <Link className="text-600" to={to}>
          {title}
        </Link>
      </li>
    ))}
  </ul>
);

FooterList.propTypes = { list: PropTypes.array.isRequired };

const FooterBlogList = ({ list }) => (
  <ul className="list-unstyled">
    {list.map((blog, index) => (
      <li key={index}>
        <h5 className="fs-0 mb-0">
          <Link className="text-600" to={blog.to}>
            {blog.title}
          </Link>
        </h5>
        <p className="text-600 opacity-50">
          {blog.date} &bull; {blog.read}{' '}
          {blog.star && (
            <span dangerouslySetInnerHTML={createMarkup('&starf;')} />
          )}
        </p>
      </li>
    ))}
  </ul>
);

FooterBlogList.propTypes = { list: PropTypes.array.isRequired };

const FooterStandard = ({ configs }) => {
  if (is.empty(configs)) return null;

  const c = getConfigFromConfigsByKey(configs, 'LandingFooter');

  const icons = configs
    .filter(p => p.key == 'LandingFooterIcon')
    .map(p => {
      const e = _.get(p, 'extension');
      return {
        ...e,
        href: p.url,
        onClick: () => {
          //TODO:Icon after click
        }
      };
    });
  const items1 = configs
    .filter(p => p.key == 'LandingFooterItem1')
    .map(p => {
      return { title: p.title, to: p.url };
    });
  const items2 = configs
    .filter(p => p.key == 'LandingFooterItem2')
    .map(p => {
      return { title: p.title, to: p.url };
    });
  const items3 = configs
    .filter(p => p.key == 'LandingFooterItem3')
    .map(p => {
      return {
        title: p.title,
        to: p.url,
        read: p.caption,
        date: _.get(p, 'extension.date'),
        star: _.get(p, 'extension.star')
      };
    });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  return (
    <Section bg="dark" className="pt-8 pb-4 light">
      <div
        className="position-absolute btn-back-to-top cursor-pointer bg-dark"
        onClick={scrollToTop}
      >
        <FontAwesomeIcon
          icon="chevron-up"
          transform="rotate-45"
          className="text-600"
        />
      </div>
      <Row>
        <Col lg={4}>
          <FooterTitle>{c.title}</FooterTitle>
          <p className="text-600">{c.caption}</p>
          <IconGroup className="mt-4" icons={icons} />
        </Col>
        <Col className="ps-lg-6 ps-xl-8">
          <Row className="mt-5 mt-lg-0">
            <Col xs={6} md={3}>
              <FooterTitle>{_.get(c, 'extension.item1Name')}</FooterTitle>
              <FooterList list={items1} />
            </Col>
            <Col xs={6} md={3}>
              <FooterTitle>{_.get(c, 'extension.item2Name')}</FooterTitle>
              <FooterList list={items2} />
            </Col>
            <Col className="mt-5 mt-md-0">
              <FooterTitle>{_.get(c, 'extension.item3Name')}</FooterTitle>
              <FooterBlogList list={items3} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Section>
  );
};

FooterStandard.propTypes = {
  configs: PropTypes.array
};

export default FooterStandard;
